import { createFileRoute } from '@tanstack/react-router'

import { filtrosDaBusca, type FiltrosDoHistorico } from '@/lib/historico'

import { TelaDoHistorico } from '@/components/gestor/historico/TelaDoHistorico'

/** O recorte da lista mais o registro aberto (`detalhe`) e, nele, o pedido de restaurar. */
export interface BuscaDoHistorico {
  aba?: FiltrosDoHistorico['aba'] | undefined
  pessoa?: FiltrosDoHistorico['pessoa'] | undefined
  dia?: FiltrosDoHistorico['dia'] | undefined
  ordem?: FiltrosDoHistorico['ordem'] | undefined
  detalhe?: number | undefined
  restaurar?: true | undefined
}

/*
 * `/gestor/historico`: a lista do que mudou na Área do Gestor. O recorte (aba,
 * pessoa, dia e ordem) e o registro aberto vivem na URL, para recarregar ou
 * mandar o link refazer a mesma tela. Valor que a API recusaria some da URL em
 * vez de virar erro (`filtrosDaBusca`). Não há exigência de cargo na casca:
 * todo cargo recebe a aba, e a API devolve só as linhas que o dele enxerga.
 */
export const Route = createFileRoute('/gestor/historico')({
  validateSearch: (busca: Record<string, unknown>): BuscaDoHistorico => {
    const { aba, pessoa, dia, ordem } = filtrosDaBusca(busca)
    const detalhe = Number(busca.detalhe)
    const aberto = busca.detalhe !== '' && Number.isSafeInteger(detalhe) && detalhe > 0
    // Toda chave sai, mesmo vazia: o roteador junta o que o validador devolve
    // à busca crua, e só uma chave presente com `undefined` apaga o valor
    // inválido que veio no endereço.
    return {
      aba,
      pessoa,
      dia,
      ordem,
      detalhe: aberto ? detalhe : undefined,
      restaurar:
        aberto && (busca.restaurar === true || busca.restaurar === 'true') ? true : undefined,
    }
  },
  component: TelaDoHistorico,
})
